import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AnalyticsWeeklyDetailPage } from '@pages/analytics';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/weekly/$weekId')({
  component: AnalyticsWeeklyDetailRoute,
  validateSearch: z.object({
    source: z.enum(['sync/sync', 'postgres/generated']).optional(),
    resource: z.literal('weekly').optional(),
  }),
});

function AnalyticsWeeklyDetailRoute() {
  const { locale, weekId } = Route.useParams();
  const { source, resource } = Route.useSearch();
  return (
    <AnalyticsWeeklyDetailPage
      locale={locale}
      weekId={weekId}
      source={source}
      resource={resource}
    />
  );
}
